/**
 * Сохранение выгрузки в файл.
 *
 * Экран «Выгрузка данных» существует ради одной вещи — отдать данные человеку.
 * Сервер их отдавал: в ответе POST /api/v1/reports/export лежит готовый CSV или
 * JSON со всеми строками. До браузера они доезжали, а пользователю не доставались:
 * кнопка «Выгрузить» показывала только «N строк» и писала запись в журнал.
 */
export function downloadText(filename: string, content: string, mime: string): void {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Освобождаем ссылку не сразу: Safari успевает начать скачивание не мгновенно.
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/** Сохранение готового файла (картинка QR-кода и т. п.) под заданным именем. */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

export function exportFilename(dataset: string, format: string, from: string, to: string): string {
  const day = (iso: string): string => iso.slice(0, 10);
  return `${dataset}_${day(from)}_${day(to)}.${format}`;
}

export const EXPORT_MIME: Readonly<Record<string, string>> = {
  csv: 'text/csv',
  json: 'application/json',
};
